import styles from './style.module.css'

const ConferenceCardList = ({children}) => {
    return <div className={styles.cardList}>
    {children}
  </div>
}
 
export default ConferenceCardList;